const TKN = "tkn";
const REG = "reg";

const Storage = {
  setToken(memberId: string) {
    window.localStorage.setItem(TKN, memberId);
  },

  getToken(): string {
    return window.localStorage.getItem(TKN) || "";
  },

  removeToken() {
    window.localStorage.removeItem(TKN);
  },

  setRegisterFlag(flag: string) {
    window.localStorage.setItem(REG, flag);
  },

  getRegisterFlag(): string {
    return window.localStorage.getItem(REG) || "";
  },

  removeRegisterFlag() {
    window.localStorage.removeItem(REG);
  },
};

export default Storage;
